import register from '../../../../global/js/registry';
export default register('m-video-overlay', () => import(/* webpackMode: "lazy" */ './m-video-overlay.controller'));
